import InstructionsBySelection from './InstructionsBySelection';

export default InstructionsBySelection;
